import {Image, ImageProps} from '@chakra-ui/react'

export default function Logo(props: ImageProps) {
  return <Image src="/img/Telepaquetes.svg" alt="Telepaquetes" {...props} />
}
